import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { ROUTE_PATH } from "@/constants/routeConstants";
import { useVerifiedSession } from "@/hooks/useVerifiedSession";

interface PublicRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

const PublicRoute = ({
  children,
  redirectTo = ROUTE_PATH.ROUTE_DASHBOARD,
}: PublicRouteProps) => {
  const { loading } = useSelector((state: RootState) => state.auth);
  const isVerified = useVerifiedSession();
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const hasAuthParams = urlParams.has("code") || urlParams.has("state") || urlParams.has("error");

  if (hasAuthParams) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600'></div>
      </div>
    );
  }

  if (isVerified) {
    const state = location.state as { from?: { pathname?: string } } | undefined;
    const targetPath = state?.from?.pathname || redirectTo;
    return <Navigate to={targetPath} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
